import React from 'react';
import { ParameterType, Type } from '../apiref/apireftypes';
import { ApiRef } from '../fasades/apiref';

export function createTrainPerformance() : ParameterType
{
    const desc = (<>
        <h3>Train Performance</h3>
        <p>Performance metrics for a single training example. Each entry in the performance array represents the evaluation results for one of the response samples provided during training.</p>
        </>);

    return {
        id          : "TrainPerformance",
        name        : "TrainPerformance",
        description : desc,
        type        : Type.Object,
        parameters  : [
            {
                "name"        : "id",
                "type"        : "number",
                "description" : <p>The identifier of the response sample (Start index is 1).</p>,
                "optional"    : false
            },
            {
                "name"        : "advantage",
                "type"        : "number",
                "description" : <p>The advantage value for this response sample. Positive values indicate the model should prefer this response, negative values indicate it should avoid it. This is calculated based on the reward values provided in the training data.</p>,
                "optional"    : true
            },
            {
                "name"        : "accuracy",
                "type"        : "number",
                "description" : <p>The accuracy of the model's prediction for this response sample, measured as the percentage of tokens that match the target response (where a match is considered if the probability is above 50%).</p>,
                "optional"    : true
            },
            {
                "name"        : "loss",
                "type"        : "number",
                "description" : <p>The loss value for this response sample in PPL (perplexity). Perplexity measures how well the model predicts the next token - lower values indicate better performance. This represents how well the model's predictions match the target response.</p>,
                "optional"    : false
            },
            {
                "name"        : "step_no",
                "type"        : "number",
                "description" : <p>Present in streaming performance chunks. The training step number (0-indexed).</p>,
                "optional"    : true
            }
        ]
    };
}

export function createTrainPerformances() : ParameterType
{
    const childType = ApiRef.getType("TrainPerformance");

    const desc = (<>
        <p>An array of performance metrics, one for each response sample provided in the training data.</p>
        </>);

    return {
        id          : "TrainPerformance[]",
        name        : "TrainPerformances",
        description : desc,
        type        : Type.Array,
        childType   : childType
    };
}

